<template>
  <animated-number :value="value" :formatValue="formatValue" :duration="animationDuration" />
</template>
<script>
import AnimatedNumber from 'animated-number-vue';

/*
 * A balance/amount readout that animates changes but never animates itself into
 * existence.
 *
 * `animated-number-vue` starts its internal value at 0 and animates up to the
 * real one in `mounted`, so any remount replays a count-up from zero. The
 * wallet is rendered inside the page layout, which is torn down and rebuilt
 * whenever the member toggles between Tài Xỉu and cockfight -- so a balance
 * that never changed appeared to refresh on every toggle.
 *
 * The first frame therefore runs with a zero duration, which anime.js snaps
 * straight to the final value. The child's `mounted` hook runs before ours, so
 * by the time we restore the real duration the initial render has already
 * settled, and every later change animates as intended.
 */
export default {
  name: 'AnimatedAmount',
  components: {
    AnimatedNumber,
  },
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    formatValue: {
      type: Function,
      required: true,
    },
    duration: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      animationDuration: 0,
    };
  },
  mounted() {
    this.animationDuration = this.duration;
  },
};
</script>
